import { render, staticRenderFns } from "./NewSputum.vue?vue&type=template&id=19da2139&scoped=true"
import script from "./NewSputum.vue?vue&type=script&lang=js"
export * from "./NewSputum.vue?vue&type=script&lang=js"
import style0 from "./NewSputum.vue?vue&type=style&index=0&id=19da2139&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19da2139",
  null
  
)

export default component.exports